import React, { FC, useMemo } from "react";
import { InputField, INPUT_TYPES, View } from "@lookiero/aurora";
import { useI18n, useI18nMessage } from "@lookiero/i18n-react";
import { Answer } from "../../../../../../domain/entities/order/Order";
import { Question } from "../../../../../../domain/entities/question/Question";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { style as feedbackListStyle } from "./FeedbackList.style";

interface FeedbackSelectQuestionProps {
  readonly question: Question;
  readonly answers?: Answer[];
  readonly onChangeField: (questionId: string, value: string) => void;
}

const FeedbackSelectQuestion: FC<FeedbackSelectQuestionProps> = ({ question, answers, onChangeField }) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });
  const questionLabelText = useI18nMessage({
    domain: DOMAIN,
    id: question.key,
  });
  const emptyOptionText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.EMPTY_OPTION,
  });

  const inputFieldOptions = [
    {
      name: emptyOptionText,
      value: emptyOptionText,
    },
    ...question.answers.map((answer) => ({
      name: formatMessage({ id: answer.key }),
      value: answer.id,
    })),
  ];

  const answer = answers ? answers.find((answer: Answer) => answer.questionId === question.id)?.answerId || "" : "";
  const value = answer;

  const style = useMemo(() => feedbackListStyle(), []);

  return (
    <View key={question.id} style={style.fieldWrapper}>
      <InputField
        key={question.id}
        defaultValue={value}
        icon="arrow_down"
        label={questionLabelText}
        name="question"
        options={inputFieldOptions}
        testID="feedback-question"
        type={INPUT_TYPES.text}
        value={value}
        onChange={(value) => onChangeField(question.id, value as string)}
      />
    </View>
  );
};

export { FeedbackSelectQuestion };
